import React from 'react';
import { Permission } from '@cnx-saas/common';
import { useAuth } from './hooks';

function RequireAuth({
  children,
  unauthenticatedComponent,
  roles,
  unauthorizedComponent,
  loadingComponent,
}: {
  children: JSX.Element;
  unauthenticatedComponent?: JSX.Element;
  roles?: Permission[];
  unauthorizedComponent?: JSX.Element;
  loadingComponent?: JSX.Element;
}) {
  const auth = useAuth();

  if (!auth.initialized) {
    return loadingComponent ?? <div>Loading...</div>;
  }

  if (!auth.authenticated) {
    return unauthenticatedComponent ?? null;
  }

  if (!auth.authorized(roles)) {
    return unauthorizedComponent ?? null;
  }

  return children;
}

export { RequireAuth };
